import React, { useState } from 'react';
import { Confirm, useDataProvider, useNotify, useRecordContext, useRefresh, useResourceContext, useTranslate } from 'react-admin';
import { Button } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';

import { useNotifyError } from 'utils/notifiers/useNotifyError';


export const RotateButton = ({ label, title, content, notifyMessage }) => {
	const record = useRecordContext();
	const resource = useResourceContext();
	const dataProvider = useDataProvider();
	const translate = useTranslate();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const refresh = useRefresh();

	const [open, setOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const handleClick = (e) => {
		e.stopPropagation();
		setOpen(true);
	};

	const handleClose = () => setOpen(false);

	const handleConfirm = async () => {
		if (!record) return;
		setIsLoading(true);
		try {
			await dataProvider.updatePartial(resource, {
				id: record.id,
				data: { rotate: true },
			});
			notify(translate(notifyMessage), 'info');
			refresh();
		} catch (error) {
			notifyError(error);
		} finally {
			setIsLoading(false);
			setOpen(false);
		}
	};

	return (
		<>
			<Button onClick={handleClick} size="small" startIcon={<RefreshIcon />}>
				{translate(label)}
			</Button>
			<Confirm
				isOpen={open}
				loading={isLoading}
				title={title}
				content={content}
				onConfirm={handleConfirm}
				onClose={handleClose}
				confirm="osfc.buttons.confirm"
			/>
		</>
	);
};
